export const ALLOW_ANNUAL_PREMIUM_PLAN = 'allow_annual_premium_plan';
export const SHOW_SEP_COUPONS = 'show_sep_coupons';
export const SHOW_ZENDESK_COUPONS = 'show_zendesk_coupons';
export const ALLOW_ANNUAL_COUPONS = 'allow_annual_coupons';
export const ALLOW_MULTIPLE_PAYMENT_METHODS = 'allow_multiple_payment_methods';
export const ALLOW_NEW_MISSED_PAYMENT_FLOW = 'allow_new_missed_payment_flow';
export const ALLOW_UPGRADE_MONTHLY_PREMIUM_TO_ANNUAL = 'allow_upgrade_monthly_premium_plan_to_annual';
